import styled from 'styled-components';

export default styled.button`
  font-size: 12px;
  line-height: 18px;
  border: none;
  border-bottom: 2px solid ${(props) => props.theme.colors.text};
  cursor: pointer;
  background-color: transparent;
  padding: 0;
  padding-bottom: 3px;
  display: inline-block;
  outline: 0;
  transition: all 0.2s ease;

  &:hover {
    border-bottom: 2px solid ${(props) => props.theme.colors.secondary};
  }

  &:disabled {
    color: ${(props) => props.theme.colors.greyDark};
    border-bottom: 2px solid ${(props) => props.theme.colors.greyDark};
  }
`;
